/**
 * Chief of Staff mode: the profile a Manager's chat may be made with
 * (design/2026-10-22-chief-of-staff-and-demos.md; the checkbox in Session
 * options, design/2026-10-26-chief-of-staff-agents-panel.md T1).
 *
 * A Chief of Staff chat is created with the profile `chief-of-staff`: its agent
 * may hand parts of the work to sub-agents and workflows and waits for their
 * results. goapi refuses that profile for anyone but a Manager. The mode only
 * changes what a NEW chat is made with; a chat's profile is fixed at create.
 */

export type AgentMode = 'normal' | 'chief-of-staff'

/** The profile id goapi knows a Chief of Staff chat by (`agenthost.ProfileChiefOfStaff`). */
export const CHIEF_OF_STAFF_PROFILE = 'chief-of-staff'

export const CHIEF_OF_STAFF_LABEL = 'Chief of Staff'

/** The profile a new chat is created with for a mode; a Normal chat sends none. */
export function profileForMode(mode: AgentMode): string | undefined {
  return mode === 'chief-of-staff' ? CHIEF_OF_STAFF_PROFILE : undefined
}

/** True when a session's stored profile (`metadata.profile`) is Chief of Staff. */
export function isChiefOfStaffProfile(profile: unknown): boolean {
  return profile === CHIEF_OF_STAFF_PROFILE
}
